import React from "react";
import { AboutUsModel } from "../../../domain/entities/AboutUsModel";

interface AboutUsComponentsProps {
    aboutUs: AboutUsModel;
}

const AboutUsComponents: React.FC<AboutUsComponentsProps> = ({aboutUs}) => {
    return (
        <div className="flex flex-col">
            <h2 className="text-2xl font-poppins font-bold text-black text-center mt-4">{aboutUs.title}</h2>
            <p className="text-sm font-poppins text-gray-600 text-justify md:text-center mt-2 mx-6 md:mx-80">{aboutUs.description}</p>
        </div>
    );
}

export default AboutUsComponents;